import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import CreateMeetingForm from "../components/meetings/CreateMeetingForm";
import { meetingService } from "../services/meetingService";
import { accountService } from "../services/accountService";
import { subscriptionService } from "../services/subscriptionService";
import { getActionRadiusKm } from "../lib/actionRadius";
import { useProfileCatalogs } from "../hooks/useProfileCatalogs";
import { useAuthStore } from "../stores/authStore";
import { ArrowLeft } from "@phosphor-icons/react";

export default function CreateMeetingPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.user?.id);
  const catalogs = useProfileCatalogs();
  const [radiusKm, setRadiusKm] = useState(getActionRadiusKm());

  useEffect(() => {
    subscriptionService.getCurrent().then((sub) => {
      setRadiusKm(getActionRadiusKm(sub?.currentPlanId));
    });
  }, []);

  const profileQuery = useQuery({
    queryKey: ["user", "profile", userId],
    queryFn: () => accountService.getProfile(),
    enabled: userId != null,
  });

  const defaults =
    profileQuery.data != null
      ? {
          preferences: profileQuery.data.preferences ?? [],
          interests: profileQuery.data.interests ?? [],
          physicalAttributes: profileQuery.data.physicalAttributes ?? [],
        }
      : null;

  async function handleSubmit(values) {
    try {
      const created = await meetingService.create(values);
      toast.success("Encuentro creado.");
      navigate(`/meetings/${created.id}`);
    } catch (err) {
      toast.error(err.message || "No se pudo crear el encuentro");
    }
  }

  return (
    <div className="px-5 pt-6" data-testid="create-meeting-page">
      <div className="mx-auto max-w-3xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[rgba(255,255,255,0.55)] hover:text-[#f5f5f5]"
          data-testid="create-back-button"
        >
          <ArrowLeft size={14} weight="thin" /> Volver
        </button>
        <header className="mb-6">
          <p className="zx-label">Organizo</p>
          <h1 className="font-serif text-3xl tracking-tight md:text-4xl">
            Tiende la cita
          </h1>
          <p className="mt-2 text-sm text-[rgba(255,255,255,0.65)]">
            Elige un hotel dentro de tu radio de acción para situar el encuentro
            en el mapa. La dirección exacta solo se mostrará cuando cierre el
            cupo.
          </p>
        </header>

        {defaults && !profileQuery.isError ? (
          <CreateMeetingForm
            defaults={defaults}
            onSubmit={handleSubmit}
            catalogs={catalogs}
            radiusKm={radiusKm}
          />
        ) : profileQuery.isError ? (
          <p className="text-xs uppercase tracking-[0.22em] text-[#e9b5c5]">
            {profileQuery.error?.message || "No se pudo cargar el perfil"}
          </p>
        ) : (
          <p className="text-xs uppercase tracking-[0.22em] text-[rgba(255,255,255,0.45)]">
            Cargando…
          </p>
        )}
      </div>
    </div>
  );
}
